import { getBrowserId, getSettings, handleGetSettingsError } from '@sitecore-cloudsdk/core';
import { IdentityEvent } from './identity-event';
import { awaitInit } from '../../initializer/browser/initializer';
import { sendEvent } from '../send-event/sendEvent';
import { ErrorMessages } from '../../consts';
/**
 * A function that sends an IDENTITY event to SitecoreCloud API
 * @param eventData - The required/optional attributes in order to be send to SitecoreCloud API
 * @param extensionData - The optional extensionData attributes that will be sent to SitecoreCloud API.
 * This object will be flattened and sent in the ext object of the payload
 * @returns The response object that Sitecore EP returns
 */
export async function identity(eventData, extensionData) {
    await awaitInit();
    const settings = handleGetSettingsError(getSettings, ErrorMessages.IE_0004);
    const id = getBrowserId();
    return new IdentityEvent({
        eventData,
        extensionData,
        id,
        sendEvent,
        settings,
    }).send();
}
